const icons = {
  CREDIT_CARD: 'ic-payment-card',
  ECHECK: 'ic-e-check',
  ACH: 'ic-payment-online',
}

const texts = {
  CREDIT_CARD: 'creditCard',
  ECHECK: 'echeck',
  ACH: 'ACH',
}

export default {
  icons,
  texts,
}
